var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckoutPaymentError = function SvgCheckoutPaymentError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 152,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F8FF",
    d: "M76 151.884c41.943 0 75.943-34 75.943-75.942S117.943 0 76.001 0 .059 34 .059 75.942s34 75.942 75.942 75.942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EC008C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.4,
    d: "M45.645 52h63.859a3.99 3.99 0 0 1 3.991 3.991v43.604a3.99 3.99 0 0 1-3.991 3.991h-63.86a3.99 3.99 0 0 1-3.99-3.991V55.991M45.644 52a3.99 3.99 0 0 0-3.99 3.991M45.644 52a3.99 3.99 0 0 0-3.99 3.991M45.644 52h13.212m-17.202 3.991v13.291m71.92 17.023v13.29a3.99 3.99 0 0 1-3.991 3.992h-13.29m17.281-34.306v-13.29A3.99 3.99 0 0 0 109.583 52h-13.37.08m-37.437 51.587h-13.29a3.994 3.994 0 0 1-3.992-3.991V86.305"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC008C",
    d: "M41.574 84h72v8h-72z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    x: 113.574,
    y: 3,
    fill: "#FE4B58",
    rx: 17
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M124.874 14.299a.85.85 0 0 1 1.202 0l4.499 4.499 4.499-4.5a.85.85 0 0 1 1.202 1.203L131.777 20l4.499 4.499a.85.85 0 1 1-1.202 1.202l-4.499-4.499-4.499 4.499a.85.85 0 1 1-1.202-1.202L129.373 20l-4.499-4.499a.85.85 0 0 1 0-1.202"
  })));
};
export default SvgCheckoutPaymentError;